import * as React from 'react';
import { SVGIconRender } from './SVGIconRender';

interface IconProps {
  color?: string;
  size?: string;
  bgFillColor?: string;
}

const About = ({
  color = 'black',
  bgFillColor = 'black',
  size = 'md'
}: IconProps) => {
  return (
    <SVGIconRender
      size={size}
      color={color}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99909 6.66683C9.88409 6.66683 9.79075 6.76016 9.79159 6.87516C9.79159 6.99016 9.88492 7.0835 9.99992 7.0835C10.1149 7.0835 10.2083 6.99016 10.2083 6.87516C10.2083 6.76016 10.1149 6.66683 9.99909 6.66683"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 17.5V17.5C5.8575 17.5 2.5 14.1425 2.5 10V10C2.5 5.8575 5.8575 2.5 10 2.5V2.5C14.1425 2.5 17.5 5.8575 17.5 10V10C17.5 14.1425 14.1425 17.5 10 17.5Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99992 10V14.1667"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SVGIconRender>
  );
};

export default About;
